import React from "react";
import EAButton from "../../../shared/Buttons/EAButton";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { State } from "../../../../store";
import { Ticket } from "../../../../models/Ticket";

interface IProps {
  ticketName: string;
  onSetOpenChangeDate: () => void;
  onSetOpenQrModal: () => void;
  ticket: Ticket;
}

const SingleFutureTicketActions: React.FC<IProps> = ({ ticketName, onSetOpenChangeDate, onSetOpenQrModal, ticket }) => {
  const { t } = useTranslation();
  const allowToChangeDate = useSelector((state: State) => state.config.configuration.allowReservedExerciseChange);

  return (
    <div className="single-future-ticket-actions">
      {ticketName !== "REZERWACJA" && (allowToChangeDate || ticket.isExerciseSelfService) && (
        <EAButton title={t("zmien_termin")} onClick={onSetOpenChangeDate} variant="outlined" />
      )}
      <EAButton title={t("pokaz_kod_qr")} onClick={onSetOpenQrModal} />
    </div>
  );
};

export default SingleFutureTicketActions;
